function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createElement } from 'react';
import isReactComponent from './isReactComponent';
import styled from 'styled-components';

var filterProps = function filterProps(props, allowedProps) {
  return allowedProps.filter(function (prop) {
    return allowedProps.includes(prop);
  }).reduce(function (acc, prop) {
    return _objectSpread({}, acc, _defineProperty({}, prop, props[prop]));
  }, {});
};
/**
 * [description withDynamicTag]
 * Higher order component that takes in a `styled` generated
 * component and returns a component that uses an internal
 * registry of extended Components and prevents _multiple_
 * Components of different tag types from being generated.
 *
 * @param  {} Component # Base styled-component to make dynamic
 * @param  {} allowedProps=[] # Set of props to allow into
 *
 * Got this function from core contributor to `styled-components`
 * https://twitter.com/_philpl/status/890365204109950976
 * https://codesandbox.io/s/n5nRmZBv4
 */


export default (function (Component) {
  var allowedProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var bucket = new WeakMap();
  var strings = Object.create(null);

  var DynamicTag = function DynamicTag(props) {
    var tag = props.tag;
    var filteredProps = allowedProps.length ? filterProps(props, ['children'].concat(_toConsumableArray(allowedProps))) : props; // If something is not a valid component
    // or has the ability to be styled, then
    // just create the element without doing
    // anything

    if (typeof tag === 'undefined' || !isReactComponent(tag) && !styled.hasOwnProperty(tag)) {
      return createElement(Component, filteredProps);
    } // If an extended styled component has not
    // been defined in the cache yet, we add it


    var extendedComponent;

    if (typeof tag === 'string') {
      // If we're using a tag string check if its in cache
      if (strings[tag] === undefined) {
        // If not, create a new extendedComponent with it
        extendedComponent = Component.withComponent(tag);
        strings[tag] = extendedComponent;
      } else {
        // Otherwise, grab the extendedComponent from cache
        extendedComponent = strings[tag];
      }
    } else {
      // If we're using an extendedComponent, use the WeakMap
      // Allows for multiple extendedComponents with same name
      // Prevents accidental overwrites
      if (!bucket.has(tag)) {
        extendedComponent = Component.withComponent(tag);
        bucket.set(tag, extendedComponent);
      } else {
        extendedComponent = bucket.get(tag);
      }
    } // Return the now cached extended styled extendedComponent


    return createElement(extendedComponent, filteredProps);
  };

  var name = Component.displayName || Component.name;
  DynamicTag.displayName = "DynamicTag(".concat(name, ")");
  return DynamicTag;
});